import { render, staticRenderFns } from "./OrdersQueue.vue?vue&type=template&id=0d32e0a9&scoped=true"
import script from "./OrdersQueue.vue?vue&type=script&lang=js"
export * from "./OrdersQueue.vue?vue&type=script&lang=js"
import style0 from "./OrdersQueue.vue?vue&type=style&index=0&id=0d32e0a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d32e0a9",
  null
  
)

export default component.exports